import { apiClient } from "@/api";
import type { DashboardStatsResponse } from "@/types/dashboard";

import type { AxiosRequestConfig } from "axios";

export type { DashboardStats, DashboardStatsResponse } from "@/types/dashboard";

export const getDashboardStats = async (config?: AxiosRequestConfig): Promise<DashboardStatsResponse> => {
  const { data } = await apiClient.get<DashboardStatsResponse>(
    "/admin/dashboard/",
    config
  );
  return data;
};
